// extracted by mini-css-extract-plugin
export default {"bannersDisplayAdsContainer":"BannersDisplayAds_bannersDisplayAdsContainer__tC24n","tabContainer":"BannersDisplayAds_tabContainer__UGluH"};